import type { NodeType } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { dropPoint } from '@tiptap/pm/transform';
import type { EditorView } from '@tiptap/pm/view';

// The line holds only its field, so the schema would wrap typed, pasted or dropped text in a new, unconfigured field.
const getFormFieldLinePlugin = (lineType: NodeType): Plugin => {
  const isOnLine = (view: EditorView) => view.state.selection.$from.parent.type === lineType;

  return new Plugin({
    key: new PluginKey('formFieldLine'),
    props: {
      handleTextInput: isOnLine,
      handlePaste: isOnLine,
      // A drop lands where it is let go, not at the selection: the place ProseMirror's own drop would choose.
      handleDrop: (view, event, slice) => {
        const at = view.posAtCoords({ left: event.clientX, top: event.clientY });
        if (!at) return false;
        const pos = dropPoint(view.state.doc, at.pos, slice) ?? at.pos;
        return view.state.doc.resolve(pos).parent.type === lineType;
      },
    },
  });
};

export default getFormFieldLinePlugin;
